import { useEffect } from 'react'

const ACTIVE_TABS_KEY = 'activeTabs'

const useActiveTab = (tabIdKey, tabs) => {
    const tabsStored = JSON.parse(sessionStorage.getItem(ACTIVE_TABS_KEY)) || {}

    const setTabStored = tabsToSet => {
        let currentTabsStored = tabsStored
        currentTabsStored[tabIdKey] = tabsToSet
        sessionStorage.setItem(
            ACTIVE_TABS_KEY,
            JSON.stringify(currentTabsStored),
        )
    }

    useEffect(() => {
        if (tabsStored[tabIdKey] == null || tabsStored[tabIdKey] == undefined) {
            setTabStored(
                tabs?.map(item => {
                    return {
                        key: item?.key,
                        active: item?.active || false,
                    }
                }),
            )
        }
    }, [tabsStored])

    const toggleActiveTab = tabKey => {
        let currentTabsStored = tabsStored
        if (tabIdKey) {
            const tabInfo =
                currentTabsStored[tabIdKey]?.find(
                    item => item?.key === tabKey,
                ) || null
            if (tabInfo != null) {
                currentTabsStored = currentTabsStored[tabIdKey]?.map(item => {
                    return {
                        ...item,
                        active:
                            tabInfo?.key === item?.key
                                ? !tabInfo?.active
                                : false,
                    }
                })
                setTabStored(currentTabsStored)
            }
        }
    }

    const getActiveTab = () => {
        return (
            tabsStored[tabIdKey]?.find(item => item?.active === true) || tabs[0]
        )
    }

    return {
        toggleActiveTab,
        getActiveTab,
    }
}

export default useActiveTab
